import { Alert, Button, Empty, Skeleton } from 'antd';
import { useGetSharedArtifactCollectionQuery } from 'api/InboxApi';
import PublicArtifactCollectionRenderer from 'components/Artifacts/PublicArtifactCollectionRenderer';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import { useParams } from 'react-router-dom';

const isEmptyPreviewState = (status?: number | string) => {
  const numericStatus = Number(status);
  return numericStatus === 400 || numericStatus === 404 || numericStatus === 410;
};

export function SharedArtifactCollectionPage() {
  const { shareId } = useParams();
  const { data, isLoading, error, refetch } = useGetSharedArtifactCollectionQuery(
    { shareId: shareId || '' },
    { skip: !shareId }
  );
  const status = (error as { status?: number | string } | undefined)?.status;
  const showEmptyState = !isLoading && (!shareId || isEmptyPreviewState(status) || (!!data && !data.collection.items.length));
  const showErrorState = Boolean(error) && !isEmptyPreviewState(status);

  return (
    <div className="layout-full-height">
      <Header />

      <ContainerComponent className="layout-main-content">
        <div style={{ padding: '32px 0 48px' }}>
          {isLoading && <Skeleton active paragraph={{ rows: 6 }} />}

          {showErrorState && (
            <Alert
              type="error"
              showIcon
              message="We couldn’t load your shared artifacts right now."
              action={
                <Button size="small" onClick={() => refetch()}>
                  Refresh
                </Button>
              }
            />
          )}

          {showEmptyState && <Empty description="No shared artifacts are available yet." />}

          {!isLoading && !showErrorState && data && data.collection.items.length > 0 && (
            <PublicArtifactCollectionRenderer
              branding={data.branding}
              items={data.collection.items}
              showKeepCard={false}
              showTopbar={false}
              {...(data.allowDownloads ? { allowDownloads: true } : {})}
              {...(data.downloadZipUrl ? { downloadZipUrl: data.downloadZipUrl } : {})}
            />
          )}
        </div>
      </ContainerComponent>

      <Footer />
    </div>
  );
}

export default SharedArtifactCollectionPage;